<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>Tableau settings</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="tableauEditForm">

    @if (isUnderMachineGroup) {
      <div class="form-group">
        <label><span translate>Tableau Projects</span></label>
        @if (isLoadingTableauProjects) {
          <span class="fa-solid fa-spinner fa-spin"></span>
        }
        <ng-select (change)="onTableauProjectChange($event);"
          [clearable]="false"
          [items]="tableauProjects"
          [placeholder]="selectProjectLabel"
          [title]="selectProjectLabel"
          [searchable]="true"
          bindLabel="name"
          bindValue="id"
          formControlName="tableauProject"
          id="selectTableauProject">
          <ng-template let-item="item" ng-label-tmp>
            <span [innerHTML]="item.name"></span>
          </ng-template>
          <ng-template let-item="item" ng-option-tmp>
            <strong class="d-block">
              <span [innerHTML]="item.name"></span>
            </strong>
          </ng-template>
        </ng-select>
      </div>
    }

    <div class="form-group">
      <label><span translate>Tableau Views</span></label>
      <scitis-required-field-indicator></scitis-required-field-indicator>
      @if (isLoadingTableauViews) {
        <span class="fa-solid fa-spinner fa-spin"></span>
      }
      <ng-select [clearable]="false"
        [items]="tableauViews"
        [placeholder]="selectViewLabel"
        [searchable]="true"
        bindLabel="name"
        bindValue="tableauId"
        formControlName="tableauView"
        labelForId="tableauViews"
        [searchFn]="viewsCustomSearchFunction"
        >
        <ng-template let-item="item" ng-label-tmp>
          <span [innerHTML]="item.name"></span>
        </ng-template>
        <ng-template let-item="item" ng-option-tmp>
          <strong class="d-block">
            <span [innerHTML]="item.name"></span>
          </strong>
          <span [innerHTML]="item.tableauId" class="d-block small text-muted"></span>
        </ng-template>
      </ng-select>
    </div>

    <div class="card mb-3">
      <div class="card-header py-2">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="h6 mb-0 flex-fill" translate>Date range</h3>
          </div>
          <div class="col-auto">
            <div class="btn-group btn-group-toggle" name="radioBasic" ngbRadioGroup>
              <label [class.active]="isFixedRange" class="btn btn-outline-primary btn-sm" ngbButtonLabel>
                <input (click)="selectDateRange(true)" ngbButton
                  type="radio">
                  <span translate>Fixed</span>
                </label>
                <label [class.active]="!isFixedRange" class="btn btn-outline-primary btn-sm" ngbButtonLabel>
                  <input (click)="selectDateRange(false)" ngbButton
                    type="radio">
                    <span translate>Offset</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="form-row">
              <!--START PARAMETER NAME-->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label><span translate>Start parameter name</span></label>
                  <div class="input-group">
                    <input [placeholder]="'Start parameter name ...'|translate" class="form-control"
                      formControlName="startTimeParameterName"
                      type="text">
                    </div>
                  </div>
                </div>

                <!--END PARAMETER NAME-->
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label><span translate>End parameter name</span></label>
                    <div class="input-group">
                      <input [placeholder]="'End parameter name ...'|translate" class="form-control"
                        formControlName="endTimeParameterName"
                        type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Fixed -->
                <div>

                  <div class="form-row">
                    <!--START DATE / TIME-->
                    @if (isFixedRange) {
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <scitis-date-time-picker
                            (focusOut)="onFocusOutStartTime($event)"
                            [showRequiredFieldIndicator]="false"
                            [showSeconds]="false"
                            [showTimeComponent]="!tableauPageConfiguration.useStartTimeOnlyDate"
                            [startDate]="getStartDate()"
                            [startTime]="getStartTime()"
                            [textLabel]="startTimeLabel">
                          </scitis-date-time-picker>
                          <div class="form-group">
                            <label for="useStartTimeOnlyDate" translate>Date only</label>
                            <div class="custom-control custom-switch">
                              <input (change)="onUseStartTimeOnlyDateChange($event)"
                                [checked]="tableauPageConfiguration.useStartTimeOnlyDate"
                                class="custom-control-input"
                                id="useStartTimeOnlyDate"
                                type="checkbox">
                                <label class="custom-control-label" for="useStartTimeOnlyDate"></label>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      <!-- START TIME OFFSET-->
                      @if (!isFixedRange) {
                        <div class="col-6 col-md-2">
                          <div class="form-group">
                            <label><span translate>Offset</span></label>
                            <scitis-required-field-indicator></scitis-required-field-indicator>
                            <input [ngClass]="{'is-invalid': formControls.startTimeOffsetValue.errors}" class="form-control"
                              formControlName="startTimeOffsetValue" type="number">
                              @if (formControls.startTimeOffsetValue.errors) {
                                <div class="invalid-feedback">
                                  @if (formControls.startTimeOffsetValue.errors.min || formControls.startTimeOffsetValue.errors.required) {
                                    <span
                                    translate>Requires positive integers</span>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }

                        <!--START TIME OFFSET VALUE-->
                        @if (!isFixedRange) {
                          <div class="col-6 col-md-4">
                            <div class="form-group">
                              <label><span translate>&nbsp;</span></label>
                              <ng-select (change)="onOffsetTypeChange($event)"
                                [(ngModel)]="tableauPageConfiguration.startTimeOffsetType"
                                [clearable]="false"
                                [items]="offsetTypesArray"
                                [placeholder]="'Select offset type...'|translate"
                                [searchable]="false"
                                formControlName="startTimeOffsetType"
                                id="startTimeOffsetType">
                              </ng-select>
                            </div>
                          </div>
                        }

                        <!--END DATE / TIME-->
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <scitis-date-time-picker
                              (focusOut)="onFocusOutEndTime($event)"
                              [isDisabled]="isFixedOffset"
                              [showRequiredFieldIndicator]="false"
                              [showSeconds]="false"
                              [showTimeComponent]="!tableauPageConfiguration.useEndTimeOnlyDate"
                              [startDate]="getEndDate()"
                              [startTime]="getEndTime()"
                              [textLabel]="endTimeLabel">
                            </scitis-date-time-picker>
                            <div class="form-row">

                              <div class="col-6">
                                <div class="form-group">
                                  <label for="useStartTimeOnlyDate" translate>Date only</label>
                                  <div class="custom-control custom-switch">
                                    <input (change)="onUseEndTimeOnlyDateChange($event)"
                                      [checked]="tableauPageConfiguration.useEndTimeOnlyDate"
                                      class="custom-control-input"
                                      id="useEndTimeOnlyDate"
                                      type="checkbox">
                                      <label class="custom-control-label" for="useEndTimeOnlyDate"></label>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-6">
                                  @if (!isFixedRange) {
                                    <div class="form-group">
                                      <label for="useEndTimeParameterValue" translate>Fixed</label>
                                      <div class="custom-control custom-switch">
                                        <input (change)="onUseEndTimeParameterValueChange($event)"
                                          [checked]="tableauPageConfiguration.useEndTimeParameterValue"
                                          class="custom-control-input"
                                          formControlName="useEndTimeParameterValue"
                                          id="useEndTimeParameterValue"
                                          type="checkbox">
                                          <label class="custom-control-label" for="useEndTimeParameterValue"></label>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="form-group">
                      <label><span translate>Additional parameters</span></label>
                      <input [placeholder]="'Add parameters ...'|translate" class="form-control" formControlName="additionalParameters"
                        type="text">
                      </div>
                    </form>
                  </div>
                  <scitis-modal-footer (cancelButtonPressed)="onCancel($event)"
                    (okButtonPressed)="onSave($event)"
                    [cancelButtonText]="'Cancel'|translate"
                    [disableOkButton]="disableSaveButton()"
                    [okButtonText]="'Save'|translate"
                    [showRequiredFieldsIndicator]="true">

                  </scitis-modal-footer>
